module.exports = __webpack_public_path__ + "img/CEDULASMOV.2ebd0051.svg";